import React, { useEffect, useState } from "react";
import axios from "axios";

const Modal = ({ id, onConfirm, onDecline, show }) => {
  const [userRole, setUserRole] = useState([]);
  const URL = process.env.REACT_APP_API_URL;

  const getuserRole = async () => {
    if (id) {
      try {
        const response = await axios.get(
          `${URL}job_details/job_detailsbyid/${id}`
        );
        setUserRole(response.data[0]);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (id) { // Only call if id is valid
      getuserRole();
    }
  }, [id]);
  if (!show) return null;

  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      style={{ display: show ? "block" : "none", transition: "opacity 0.5s" }}
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Apply Job
            </h5>
           
          </div>
          <div class="modal-body">
            Are you sure you want to apply for this <br />
            {userRole ? (
              <>
                <b>{userRole.role}</b> Job.
              </>
            ) : (
              <p></p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={onDecline}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={onConfirm}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;